import React, {ReactElement, ReactNode} from "react";

import Icon from "../../icon/Icon";
import LinkTag from "../../buttons/link-tag/LinkTag";
import ModuleBody from "../../layouts/module-body/ModuleBody";

import {css} from "/src/utils/utils";
import {LOCALE} from "/src/config";

import FlexportLogo from "/src/svg/flexport-light.svg";
import FlexportCNLogo from "/src/svg/flexport-cn-light.svg";

import * as styles from "./simple-header.module.scss";

interface SimpleHeaderProps {
  productName?: string;
  headerLink?: string;
  locale?: string;
  rightNav?: ReactNode;
}

const SimpleHeader = (props: SimpleHeaderProps): ReactElement => {
  const {productName, headerLink, locale = LOCALE, rightNav} = props;
  const isCN = locale === "zh-CN";

  return (
    <header className={styles.simpleHeader}>
      <ModuleBody classes={styles.simpleHeader__body}>
        <div className={styles.simpleHeader__wrapper}>
          <div className={styles.simpleHeader__logoWrapper}>
            <LinkTag ariaLabel="Flexport" href="/">
              <Icon
                classes={styles.simpleHeader__logo}
                svg={isCN ? FlexportCNLogo : FlexportLogo}
              />
            </LinkTag>
          </div>

          {headerLink && productName && (
            <LinkTag
              href={headerLink!}
              classes={css("p", styles.simpleHeader__product)}
            >
              {productName}
            </LinkTag>
          )}

          {!headerLink && productName && (
            <p className={css("p", styles.simpleHeader__product)}>
              {productName}
            </p>
          )}
        </div>

        {rightNav && (
          <div className={styles.simpleHeader__wrapper}>{rightNav}</div>
        )}
      </ModuleBody>
    </header>
  );
};

export default SimpleHeader;
